// DICOM modality codes offered in the UI. Microscopy first (what this service
// is primarily for), then the common radiology codes, then the catch-alls.
// Codes are the DICOM defined terms (0008,0060); a deployment that needs one
// not listed can still set it through a metadata file.

export interface ModalityOption {
  code: string;
  label: string;
}

export const MODALITY_OPTIONS: ModalityOption[] = [
  { code: 'SM', label: 'Slide microscopy' },
  { code: 'GM', label: 'General microscopy' },
  { code: 'XC', label: 'External camera' },
  { code: 'CT', label: 'Computed tomography' },
  { code: 'MR', label: 'Magnetic resonance' },
  { code: 'US', label: 'Ultrasound' },
  { code: 'CR', label: 'Computed radiography' },
  { code: 'DX', label: 'Digital radiography' },
  { code: 'MG', label: 'Mammography' },
  { code: 'PT', label: 'PET' },
  { code: 'NM', label: 'Nuclear medicine' },
  { code: 'XA', label: 'X-ray angiography' },
  { code: 'RF', label: 'Radiofluoroscopy' },
  { code: 'SC', label: 'Secondary capture' },
  { code: 'OT', label: 'Other' },
];

/** Codes only, for filters and validation. */
export const MODALITY_CODES = MODALITY_OPTIONS.map((m) => m.code);
